module.exports = __webpack_public_path__ + "img/phyto-rouge-photo-ambiance-13.12af5a1c.jpg";